import React, {useContext, useEffect, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import GenericEditRemoveCellRenderer from "./generic-edit-remove-cell-renderer.jsx";
import {AgentContext} from "../../context/agent-context.jsx";
import {v4 as uuidv4} from "uuid";
import CellRendererAttach from "../../utils/cell-renderer-attach.jsx";
import ConfirmationDeleteList from "../../../../../../components/utils/confirmation-delete-lists.jsx";
import {FaCalendar, FaCheck, FaPlus} from "react-icons/fa";
import Swal from "sweetalert2";
import DateExpirationRender from "./components/date-expiration-render.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import {Card} from "../../../../../../components/card/card.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import InputDatetime from "../../../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import Attach from "../../../../../../components/attach/attach.jsx";
import Button from "../../../../../../components/button/button.jsx";
import InputSwitch from "../../../../../../components/input/input-switch.jsx";
import {format} from "date-fns";
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";

const Trainings = () => {
    const generateInitialData = () => ({
        itemId: uuidv4(),
        courseName: "",
        workload: "",
        startDate: "",
        dateConclusion: "",
        dateExpedition: "",
        dateExpiration: "",
        courseFile: "",
        relatedItemId: null,
        related: false,
    });

    const gridRef = useRef();
    const {setUser, user, setTablesAttachs, tablesAttachs, setChanges, setTabSelected, setCpfFocus} = useContext(AgentContext)
    const [data, setData] = useState(generateInitialData)
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [removedFile, setRemovedFile] = useState(null);
    const [listTrainings, setListTrainings] = useState([])
    const [expirationClass, setExpirationClass] = useState({divClass: "", faIcon:  <FaCalendar className={"absolute top-[9px] right-[10px]"} />})

    const CustomTooltip = ({ value }) => {
        return (
            <div style={{
                background: "#fff",
                border: "1px solid #dddee0",
                padding: "10px",
                borderRadius: "4px",
                maxWidth: "400px",
                whiteSpace: "normal",
                wordBreak: "break-word",
                boxShadow: "0 2px 8px rgba(0,0,0,.15)",
            }}>
                {value}
            </div>
        );
    };

    useEffect(() => {
        if (open) {
            setListTrainings(user.trainings.filter(t => t.itemId !== data.itemId).map(t => {
                const dateExpiration = (t.dateExpiration ? ` - ${projectUtils.formatDate(t.dateExpiration + 'T00:00:00', 'DD/MM/YYYY')}` : "");
                return {
                    value: t.itemId,
                    label: t.courseName + dateExpiration
                }
            }))
        }
    }, [user, open]);

    useEffect(() => {
        if (open) {
            const attachFind = tablesAttachs.find(item => item.name?.includes(`trainings-${data.itemId}`));
            if (attachFind) setFile(attachFind);
        }
    }, [open]);

    const remove = (data) => {
        ConfirmationDeleteList(() => {
            setUser(prev => ({
                ...prev,
                trainings: prev.trainings.filter(dep => dep.itemId !== data.itemId)
            }));

            setTablesAttachs((prevItems) => prevItems.filter((item) => !item.name.includes(`trainings-${data.itemId}`)))
            setChanges('training');
        })
    }

    const [columnDefs] = useState([
        {headerName: "Nome", field: "courseName", flex: 1.25, comparator: aggridUtils.nullLastComparator, tooltipField: "courseName", tooltipComponent: CustomTooltip},
        {headerName: "Duração", field: "workload", valueFormatter: ({value}) => value ? parseInt(value) : null, comparator: aggridUtils.nullLastComparator, flex: 0.65},
        {
            headerName: "Data de início", field: "startDate",
            valueFormatter: ({value}) => {
                if (value) return projectUtils.formatDate(value + 'T00:00:00', 'DD/MM/YYYY');

                return null;
            }, comparator: aggridUtils.nullLastComparator, flex: 1
        },
        {
            headerName: "Data de conclusão", field: "dateConclusion",
            valueFormatter: ({value}) => {
                if (value) return projectUtils.formatDate(value + 'T00:00:00', 'DD/MM/YYYY');

                return null;
            }, comparator: aggridUtils.nullLastComparator, flex: 1.25
        },
        {headerName: "Data de validade", field: "dateExpiration", sort: "desc", cellRenderer: DateExpirationRender, comparator: aggridUtils.nullLastComparator, flex: 1.35},
        {
            headerName: "Emissão do certificado", field: "dateExpedition",
            valueFormatter: ({value}) => {
                if (value) return projectUtils.formatDate(value + 'T00:00:00', 'DD/MM/YYYY');

                return null;
            }, comparator: aggridUtils.nullLastComparator, flex: 1.5
        },
        {
            headerName: "Anexo", field: "", flex: 0.55,
            cellRenderer: ({data}) => {
                const {courseFile, itemId} = data;
                return <CellRendererAttach attachId={courseFile} itemId={itemId} target={"trainings"}/>
            }
        },
        {
            headerName: "Renovação", field: "", flex: 1,
            cellRenderer: ItemRelatedCellRenderer, cellRendererParams: {items: user.trainings},
            comparator: aggridUtils.nullLastComparator
        },
        {
            headerName: "", field: "", flex: 0.75, cellRenderer: GenericEditRemoveCellRenderer,
            cellRendererParams: {setData, setOpen, remove}
        },
    ]);

    const handleInputs = ({target: {value, id}}) => setData(prev => ({...prev, [id]: value}));
    const handleDate = (id, value) => {
        const dateFormated = value ? format(value, "yyyy-MM-dd") : null
        setData(prev => ({...prev, [id]: dateFormated}))
    };

    const handleCheckbox = (checked, id) => {
        const newData = (prev) => {
            const n = {...prev, [id]: checked};
            if (id === "related" && !checked) n.relatedItemId = "";
            return n;
        }
        setData(prev => (newData(prev)));
    }

    const save = () => {
        setUser(prevItems => {
            const exists = prevItems.trainings.some(t => t.itemId === data.itemId);

            const updatedTrainings = exists
                ? prevItems.trainings.map(t => (t.itemId === data.itemId ? data : t))
                : [...prevItems.trainings, data];

            return {
                ...prevItems,
                trainings: updatedTrainings
            };
        });

        if (file) {
            setTablesAttachs(prevItems => {
                const exists = prevItems.some(item => item.name === file.name);
                return exists ? prevItems.map(item => item.name === file.name ? file : item) : [...prevItems, file];
            });
        }

        if (removedFile) setTablesAttachs((prevItems) => prevItems.filter((item) => item.name !== removedFile.name));
        setChanges('training');

        onHide();
    }

    const onHide = () => {
        setData(generateInitialData());
        setOpen(false)
        setFile(null)
        setRemovedFile(null)
    }

    const onChangeFile = (uploadedFile) => {
        if (uploadedFile) setFile(uploadedFile);
    }

    const removeFile = (uploadedFile) => {
        if (uploadedFile) {
            setRemovedFile(uploadedFile);

            const target = "courseFile"
            setData(prev => ({...prev, [target]: null}));
        }
    }

    const handleClick = () => {
        if (!user.general.cpf){
            Swal.fire({
                title: "Atenção",
                text: "Informe o CPF para incluir formação e aperfeiçoamento.",
                icon: "warning",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#063A6C",
                cancelButtonText: "Cancelar",
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true,
            }).then(({isConfirmed}) => {
                if (isConfirmed) {
                    setTabSelected("general")
                    setCpfFocus(true)
                }
            });
        }else{
            setOpen(true)
        }
    }

    useEffect(() =>{
        let givenDate
        const today = new Date();
        const almostDate = new Date();
        almostDate.setDate(today.getDate() + 45);

        data.dateExpiration ? givenDate = new Date(data.dateExpiration) : givenDate = null

        const show = user.trainings.some((training) => {
            return training.relatedItemId === data.itemId;
        });

        if (givenDate && !show){
            if (today >= givenDate) {
                const divClass = "!text-[#dc4c64] !border-[#dc4c64]";
                setExpirationClass({divClass, faIcon: <FaTriangleExclamation color={"dc4c64"} className={"absolute top-[9px] right-[10px]"}/>});
            }else if (today <= givenDate && almostDate >= givenDate) {
                const divClass = "!text-[#FC6D00] !border-[#FC6D00]";
                setExpirationClass({divClass: divClass, faIcon: <FaCircleExclamation color={"#FC6D00"} className={"absolute top-[9px] right-[10px]"}/>});
            }else{
                setExpirationClass({divClass: "", faIcon: <FaCalendar className={"absolute top-[9px] right-[10px]"} />});
            }
        }else{
            setExpirationClass({divClass: "", faIcon: <FaCalendar className={"absolute top-[9px] right-[10px]"} />});
        }

    }, [open, data])

    return (
        <>
            <Card>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Formação e aperfeiçoamento</Card.Title>
                    <Button className={"h-[30px] w-[30px] !p-0"} onClick={() => handleClick()}>
                        <FaPlus />
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className={"h-[calc(100vh-196px)]"}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={user.trainings}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                            tooltipShowDelay={400}
                        />
                    </div>
                </Card.Body>
            </Card>

            <Modal overflow={true} isCloseClick={false} open={open} setOpen={onHide} title={"Formação e aperfeiçoamento"} className={"w-5/12"}>
                <Modal.Body className="p-2">
                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-4">
                            <InputForm id="courseName" value={data.courseName} label="Nome do curso"
                                      onChange={handleInputs}/>
                        </div>
                        <div className="col-span-4">
                            <InputForm min={0} type={"number"} id="workload" value={data.workload} label="Duração"
                                      onChange={handleInputs}/>
                        </div>
                        <div className={"col-span-4"}>
                            <div className="form-outline-custom">
                                <InputDatetime
                                    id={"dateExpedition"}
                                    selected={data.dateExpedition}
                                    label={"Emissão do certificado"}
                                    onChange={(date) => handleDate("dateExpedition", date)}
                                    dateFormat={"L"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4 mb-3" style={{height: "35px"}}>
                        <div className={"col-span-4"}>
                            <div className="form-outline-custom">
                                <InputDatetime
                                    id={"startDate"}
                                    selected={data.startDate}
                                    label={"Início"}
                                    onChange={(date) => handleDate("startDate", date)}
                                    dateFormat={"L"}
                                />
                            </div>
                        </div>
                        <div className={"col-span-4"}>
                            <div className="form-outline-custom">
                                <InputDatetime
                                    id={"dateConclusion"}
                                    selected={data.dateConclusion}
                                    label={"Conclusão"}
                                    onChange={(date) => handleDate("dateConclusion", date)}
                                    dateFormat={"L"}
                                />
                            </div>
                        </div>
                        <div className={"col-span-4"}>
                            <div className={"form-outline-custom "}>
                                <InputDatetime
                                    id={"dateExpiration"}
                                    selected={data.dateExpiration}
                                    label={"Expiração"}
                                    onChange={(date) => handleDate("dateExpiration", date)}
                                    dateFormat={"L"}
                                    customIcon={expirationClass.faIcon}
                                    inputClass={expirationClass.divClass}
                                    labelClass={expirationClass.divClass}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={"grid grid-cols-12 gap-4 align-items-center mb-3"}>
                        <div className={"col-span-5"}>
                            <InputSwitch
                                id="related"
                                label="Atualização/Renovação"
                                checked={data.related}
                                onChange={(checked) => handleCheckbox(checked, "related")}
                            />
                        </div>
                        <div className="col-span-7">
                            <SelectComponent
                                id="relatedItemId"
                                value={data?.relatedItemId ? listTrainings.find(t => t.value === data?.relatedItemId) : ""}
                                options={listTrainings}
                                label={"Item relacionado"}
                                onChange={(selected) => setData(prev => ({...prev, relatedItemId: selected?.value ?? ""}))}
                                isDisabled={!data.related}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-3">
                            <Attach onChangeFile={onChangeFile} removeFile={removeFile}
                                    itemId={`trainings-${data.itemId}`} attachedFile={file} attachId={data.courseFile} />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className={"p-1"}>
                    <div className={"w-full flex justify-end"}>
                        <Button onClick={save}>
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

const ItemRelatedCellRenderer = ({api, data}) => {
    const hasRelation = () => {
        let has = false;

        api.forEachNode(row => {
            const {relatedItemId} = row.data;
            if (relatedItemId === data.itemId) has = true
        });

        return has ? <FaCheck color={"green"} size={18}/> : "";
    }

    return(
        <>
            <span className={"flex items-center justify-center h-full"}>{hasRelation()}</span>
        </>
    )
}

export default Trainings;